<ng-content select="mbs-card-group-header" />
<ng-content />
